var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeHide(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 3L17.5309 6.46912M3 21L6.46912 17.5309M6.46912 17.5309C4.61542 16.0652 3.15899 14.2184 2.34747 13.0733C1.88418 12.4197 1.88418 11.5803 2.34747 10.9267C3.85969 8.79299 7.61134 4.22222 12 4.22222C14.0335 4.22222 15.9303 5.20358 17.5309 6.46912M6.46912 17.5309L9.64298 14.357M9.64298 14.357C9.03976 13.7538 8.66667 12.9205 8.66667 12C8.66667 10.1591 10.1591 8.66667 12 8.66667C12.9205 8.66667 13.7538 9.03976 14.357 9.64298M9.64298 14.357L14.357 9.64298M14.357 9.64298L17.5309 6.46912M9.77778 19.4003C10.4937 19.6397 11.2372 19.7778 12 19.7778C16.3887 19.7778 20.1403 15.207 21.6525 13.0733C22.1158 12.4197 22.1158 11.5803 21.6525 10.9267C21.3171 10.4534 20.8716 9.86031 20.3333 9.22377",
    stroke: "#828282",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeHide);
export default __webpack_public_path__ + "static/media/eyeHide.69eed73d295d79c7d1e1174bd65b5aa3.svg";
export { ForwardRef as ReactComponent };